function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25531",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25531",
  d: "M-63.024,26.563c2.884,1.513,6.219-1.184,4.955-4.006l-24-53.577A3.5,3.5,0,0,0-85.282-33h0A3.5,3.5,0,0,0-88.5-31.02l-24.016,53.578c-1.265,2.822,2.069,5.519,4.954,4.007l22.28-11.677,0,0ZM-85.282,7.725V-21.862l17.348,38.682-14-7.338Z",
  transform: "translate(79.779 114.182) rotate(60)",
  fill: "#3d5567"
});

var SvgPlane = function SvgPlane(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79.462,
    height: 77.631,
    viewBox: "0 0 79.462 77.631",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane.0c84cea8.svg";
export { ForwardRef as ReactComponent };